import React, { useEffect, useState } from 'react';
import { createPortal } from 'react-dom';
import { AnimatePresence, motion } from 'framer-motion';
import { rejectModalCSS } from './Cotizaciones.css';

const formatMoney = (value) => {
    if (value === null || value === undefined) return '—';
    try {
        return new Intl.NumberFormat('es-MX', {
            style: 'currency',
            currency: 'MXN',
            maximumFractionDigits: 0,
        }).format(value);
    } catch {
        return `$${value}`;
    }
};

const RejectModal = ({ visible, quote, onConfirm, onCancel, loading = false }) => {
    const [comment, setComment] = useState('');

    useEffect(() => {
        if (visible) setComment('');
    }, [visible]);

    if (typeof document === 'undefined') return null;

    return createPortal(
        <AnimatePresence>
            {visible && (
                <>
                    <motion.div
                        css={rejectModalCSS()}
                        className="rm-backdrop"
                        initial={{ opacity: 0 }}
                        animate={{ opacity: 1 }}
                        exit={{ opacity: 0 }}
                        transition={{ duration: 0.15 }}
                        onClick={loading ? undefined : onCancel}
                    />
                    <motion.div
                        css={rejectModalCSS()}
                        className="rm-panel"
                        style={{ x: '-50%', y: '-50%' }}
                        initial={{ opacity: 0, scale: 0.97 }}
                        animate={{ opacity: 1, scale: 1 }}
                        exit={{ opacity: 0, scale: 0.97 }}
                        transition={{ type: 'spring', stiffness: 400, damping: 28 }}
                        role="dialog"
                        aria-modal="true"
                    >
                        <div className="rm-header">
                            <h3 className="rm-title">Rechazar cotización</h3>
                        </div>
                        <div className="rm-body">
                            {quote && (
                                <div className="rm-summary">
                                    <div className="rm-summary-icon">
                                        <i className="pi pi-file" />
                                    </div>
                                    <div className="rm-summary-text">
                                        <span className="rm-summary-name">
                                            {quote.client?.name || quote.client?.email || 'Cliente sin nombre'}
                                        </span>
                                        {quote.client?.email && (
                                            <span className="rm-summary-sub">{quote.client.email}</span>
                                        )}
                                        <span className="rm-summary-sub">
                                            {[quote.unit, formatMoney(quote.price), quote.term ? `${quote.term} meses` : null]
                                                .filter(Boolean)
                                                .join(' · ')}
                                        </span>
                                    </div>
                                </div>
                            )}
                            <textarea
                                className="rm-textarea"
                                value={comment}
                                onChange={(e) => setComment(e.target.value)}
                                placeholder="Motivo (opcional)"
                                disabled={loading}
                            />
                            <div className="rm-actions">
                                <button
                                    type="button"
                                    className="rm-btn rm-btn-cancel"
                                    onClick={onCancel}
                                    disabled={loading}
                                >
                                    Cancelar
                                </button>
                                <button
                                    type="button"
                                    className="rm-btn rm-btn-confirm"
                                    onClick={() => onConfirm(comment)}
                                    disabled={loading}
                                >
                                    <i className={loading ? 'pi pi-spin pi-spinner' : 'pi pi-times-circle'} />
                                    Confirmar rechazo
                                </button>
                            </div>
                        </div>
                    </motion.div>
                </>
            )}
        </AnimatePresence>,
        document.body,
    );
};

export default RejectModal;
